<script>
export default {
  name: 'MemberActionButton',
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'blue',
      validator: value => ['blue', 'gold'].includes(value)
    }
  },
  methods: {
    handleClick () {
      if (!this.disabled) this.$emit('click')
    }
  }
}
</script>

<template>
  <button
    type="button"
    :class="['member-action', `member-action--${variant}`]"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ label }}
  </button>
</template>

<style scoped>
.member-action {
  width: 100%;
  min-height: 52px;
  padding: 10px 18px;
  border: 0;
  border-radius: 16px;
  font-family: 'Kanit', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: filter .2s ease, transform .2s ease, box-shadow .2s ease;
}

.member-action:hover:not(:disabled) {
  filter: brightness(1.08);
  transform: translateY(-1px);
}

.member-action:active:not(:disabled) {
  transform: translateY(1px);
}

.member-action:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
}

.member-action--blue {
  color: #071022;
  background: linear-gradient(135deg, #77aaff, #2f7bff 58%, #276cf0);
  box-shadow: 0 13px 30px rgba(34, 104, 249, .28);
}

.member-action--gold {
  color: #231600;
  background: linear-gradient(135deg, #ffe59d, #ffca52 58%, #f5ad24);
  box-shadow: 0 13px 30px rgba(255, 183, 41, .18);
}

.member-action:disabled {
  color: #6f798a;
  background: #1a2230;
  box-shadow: none;
  cursor: not-allowed;
}
</style>
